export const getBarHeights = (frequencyData: Uint8Array) => {
  const fftSize = frequencyData.length;

  const frequencyRanges = [
    [fftSize * 0.28, fftSize * 0.65],
    [fftSize * 0.03, fftSize * 0.5],
    [fftSize * 0.015, fftSize * 0.35],
    [fftSize * 0.035, fftSize * 0.5],
    [fftSize * 0.25, fftSize * 0.67],
  ];

  return frequencyRanges.map(([start, end]) => {
    const slice = frequencyData.slice(Math.floor(start!), Math.floor(end!));

    const avg =
      slice.reduce((sum: number, value: number) => sum + value, 0) / slice.length;

    const randomness = Math.sin(Math.random() / 10) * 20 * Math.random() > 0.5 ? 1 : -1;
    return ((avg * 1.75) / 255) * 50 + randomness; // Normalize and add organic variation
  });
};
